import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { isAuth, isAdmin } = useAuth();
  if (!isAuth) return <Navigate to="/extranet/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/extranet" replace />;
  return children;
}
